export enum StatusCompany {
  waiting_complete_registration = 0,
  active = 1,
  waiting_confirm_registration = 2
}
